var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.242 40.242"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 28",
    d: "m2.121 38.121 37-36"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 29",
    d: "m39.121 38.121-37-36"
  }))));
};
export { SvgX as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MS4yNDIgNDAuMjQyIj4KICA8ZyBkYXRhLW5hbWU9Ikdyb3VwIDUiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMyI+CiAgICA8cGF0aCBkYXRhLW5hbWU9IkxpbmUgMjgiIGQ9Ik0yLjEyMSAzOC4xMjFsMzctMzYiLz4KICAgIDxwYXRoIGRhdGEtbmFtZT0iTGluZSAyOSIgZD0iTTM5LjEyMSAzOC4xMjFsLTM3LTM2Ii8+CiAgPC9nPgo8L3N2Zz4=";